import url from "./api";
export const apiRoutes = {
  //User
  user: `${url}user`,
  auth: `${url}auth`,
  permission: `${url}permission`,
  project: `${url}project`,
  projectLinks: `${url}project-link`,
};
